function downloadURI(uri, name) {
  const link = document.createElement("a");
  link.download = name ?? uri;
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  link.remove();
}

export { downloadURI };
//# sourceMappingURL=dom.download-from-uri.js.map
